module.exports = __webpack_public_path__ + "img/ak3.ab15243f.webp";